/**
 * Service Layer - Handles business logic for authentication operations
 */

import {
  changePasswordApi,
  syncGooglePictureApi,
} from '../adapters/auth.adapter'
import type {
  SyncGooglePicturePayload,
  UpdatePasswordPayload,
} from '../adapters/auth.adapter'

export async function changePassword(
  userId: string,
  payload: UpdatePasswordPayload,
): Promise<void> {
  return changePasswordApi(userId, payload)
}

export async function syncGooglePicture(
  payload: SyncGooglePicturePayload,
): Promise<{ success: boolean }> {
  return syncGooglePictureApi(payload)
}
